/**
 * Component to display the attributes of a track window and allowed operations
 * @description props.data must exist, and be a TrackWindow instance
 */
import React from 'react';
import { connect } from 'react-redux';
import WindowAttribute from './WindowAttribute';
import TrackWindow from '../../model/TrackWindow';

import './WindowCard.css';

const WindowCard = (props) => {
    if (!(props.data && props.data instanceof TrackWindow)) {
        console.error('props.data is required, and need to be TrackWindow type');
        return;
    }

    const tw = props.data,      
        display_win = tw.toDisplay(),
        canCopy = props.isAuthorized && tw.canCopy(),
        canEdit = props.isAuthorized && tw.canEdit(props.userProfile.sub.toUpperCase()),
        canDelete = props.isAuthorized && tw.canEdit(props.userProfile.sub.toUpperCase());

    const attrItems = Object.entries(display_win).map((attr) => {
        const [ name, value ] = attr;

        return <WindowAttribute key = { name } fldName = { name } fldValue = { value } />
    });

    let statusItem;

    if (tw.isApproved()) {
        statusItem = (
            <div className="clsWinStatusWrapper clsApproved">
                <i className="fa fa-check-circle fa-lg"></i>
                <span className="clsWinStatus">APPROVED</span>
            </div>
        );

    } else if (tw.isPending()) {
        statusItem = (
            <div className="clsWinStatusWrapper clsPending">
                <i className="fa fa-exclamation-circle fa-lg"></i>
                <span className="clsWinStatus">PENDING</span>
            </div>
        );
    } else if (tw.isRejected()) {
        statusItem = (
            <div className="clsWinStatusWrapper clsRejected">
                <i className="fa fa-ban fa-lg"></i>
                <span className="clsWinStatus">REJECTED</span>
            </div>
        );
    } else if (tw.isCancelled()) {
        statusItem = (
            <div className="clsWinStatusWrapper clsRejected">
                <i className="fa fa-ban fa-lg"></i>
                <span className="clsWinStatus">CANCELED</span>
            </div>
        );
    } else {
        statusItem = (
            <div className="clsWinStatusWrapper ">
                <i className="fa fa-ban fa-lg"></i>
                <span className="clsWinStatus">UNKNOWN</span>
            </div>
        );
    }

    const onClick_copy = () => {
        props.copyWindow(tw);
    }

    const onClick_delete = () => {
        props.deleteWindow(tw);
    }

    const onClick_edit = () => {
        props.editWindow(tw);
    }

    const copyItem = (
        <div className='clsBtn clsBtnCopy' onClick={ onClick_copy }>COPY</div>
    );

    const deleteItem = (
        <div className='clsBtnDelete' onClick={ onClick_delete }>
            <i className="fa fa-trash fa-lg"></i>
        </div>
    )

    const editItem = (
        <div className='clsBtn clsBtnEdit' onClick={ onClick_edit }>EDIT</div>
    )

    return (
        <div className='clsWinCard'>
            <div className='clsWinAttrWrapper'>
                { attrItems }
            </div>
           
            { statusItem }
            <div className='clsBtnWrapper'>
                { canEdit ? editItem : null }
                { canCopy ? copyItem : null }
            </div>

            { canDelete ? deleteItem : null }
        </div>
    );
}

const mapStateToProps = state => {
    return {
        userProfile: state.oidc.user && state.oidc.user.profile,
        isAuthorized: state.isAuthorized
    };
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(WindowCard);